/**
 * @module custom-elements
 * @description Global Vue Configuration. Register all custom elements and load
 * them by async-imports as chunks to keep initial script size as small as
 * possible.
 *
 * Note 2018-11: We still use VueCustomElement until we can savely drop support
 * for IE11 which is not supported by the native Vue-Web-Component-Wrapper OR if
 * VWCW will one day supports IE11, see:
 * https://github.com/vuejs/vue-web-component-wrapper/issues/31
 */
import 'es6-promise/auto'
import 'es6-object-assign/auto'
import 'intersection-observer'
import installCE from 'document-register-element/pony'
import Vue from 'vue'
import VueCustomElement from 'vue-custom-element'
import Vuelidate from 'vuelidate'
import Vuex from 'vuex'
import Moment from 'moment'
import '@mein-oeamtc/lib-auth/lib/lib-auth.css'
import '@mein-oeamtc/lib-ui/lib/lib-ui.css'
import '@mein-oeamtc/lib-my-oeamtc-base/lib/lib-my-oeamtc-base.css'
import '@mein-oeamtc/lib-my-oeamtc-base/lib/img/mapbox-600x600.bbb8e292.png'
installCE(global, 'auto')

Vue.config.productionTip = false

Vue.use(VueCustomElement)
Vue.use(Vuelidate)
Vue.use(Vuex)

async function loadZxcvbn () {
  /**
   * Password validation library. Unfortunately very large in size, so only
   * require in components, that make use of it. (Chunk)
   */
  return import(/* webpackChunkName: "zxcvbn" */ 'zxcvbn')
}

Vue.filter('formatDate', function (value) {
  if (value) {
    return Moment(String(value)).format('DD.MM.YYYY hh:mm')
  }
})

Vue.customElement('oeamtc-login', () => {
  loadZxcvbn()
  return import(/* webpackChunkName: "login" */ './components/Login.vue')
    .then(m => m.default)
}, { props: ['displayComponent', 'isOverlay'] })

Vue.customElement('oeamtc-creditcard', () => {
  loadZxcvbn()
  return import(/* webpackChunkName: "creditcard" */ './components/creditcard-application/Index.vue')
    .then(m => m.default)
})

Vue.customElement('oeamtc-generic-personalisation', () => {
  return import(/* webpackChunkName: "genericpersonalisation" */ './components/GenericPersonalisation.vue')
    .then(m => m.default)
})

Vue.customElement('oeamtc-generic-voucher', () => {
  return import(/* webpackChunkName: "genericvoucher" */ './components/GenericVoucher.vue')
    .then(m => m.default)
})

Vue.customElement('oeamtc-my-oeamtc-base', () => {
  return import(/* webpackChunkName: "myoeamtcbase" */ './components/MyOeamtcBase.vue')
    .then(m => m.default)
})

Vue.customElement('oeamtc-my-oeamtc-base-button', () => {
  return import(/* webpackChunkName: "myoeamtcbasebutton" */ './components/MyOeamtcBaseButton.vue')
    .then(m => m.default)
})

Vue.customElement('oeamtc-vehicle-purchase-contract', () => {
  return import(/* webpackChunkName: "vehiclepurchasecontract" */ './components/VehiclePurchaseContract.vue')
    .then(m => m.default)
})
